import request from '@/utils/request';

// 列表
export function queryEnterprisePageList(data) {
  return request({
    url: '/enterprise/queryEnterprisePageList',
    method: 'POST',
    data
  });
}
// 新增
export function saveEnterprise(data) {
  return request({
    url: '/enterprise/saveEnterprise',
    method: 'POST',
    data
  });
}
// 编辑
export function updateEnterprise(data) {
  return request({
    url: '/enterprise/updateEnterprise',
    method: 'POST',
    data
  });
}
// 明细
export function fetchEnterpriseDetailById(data) {
  return request({
    url: '/enterprise/fetchEnterpriseDetailById',
    method: 'POST',
    data
  });
}
// 删除
export function removeEnterpriseById(data) {
  return request({
    url: '/enterprise/removeEnterpriseById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/branchOffice.js